import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SearchForNewGroupMembers from "./SearchForNewGroupMembers";
import EmailGroupMemberInvitationsControl from "./EmailGroupMemberInvitationsControl";
import "./Group.css";

function SelectGroupMembersControl({
    group,
    selectedUsers,
    onCompletedSelection
}) {

    const [processing, setProcessing] = useState(false);
    const [invitations, setInvitations] = useState({ emails: [] });
    const [activeForm, setActiveForm] = useState({ form: "jgr-users" });

    useEffect(() => {


    }, [])

    function setForm(e) {
        e.preventDefault();
        var form = e.target.title;
        setActiveForm(setActiveForm => ({
            ...setActiveForm,
            form: form
        }));
    }

    function onChangeEmails(value) {
        setInvitations(prevInvitations => ({
            ...prevInvitations,
            emails: value
        }));
    }

    return (
        <div className="select-members">
            <div className="row justify-content-center">
                <div className="profile-tab col-11">
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <a title="jgr-users" className={activeForm.form == "jgr-users" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="jgr-users" className="fas fa-user-plus mr-1"></span></a>
                            <a title="jgr-users" className={activeForm.form == "jgr-users" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="jgr-users" className="fas fa-user-plus mr-1"></span>Select JustGoRide Users</a>
                        </li>
                        <li className="nav-item">
                            <a title="email-users" className={activeForm.form == "email-users" ? "nav-link d-sm-none active" : "nav-link d-sm-none"} href="#" onClick={setForm}><span title="email-users" className="fas fa-envelope mr-1"></span></a>
                            <a title="email-users" className={activeForm.form == "email-users" ? "nav-link d-none d-sm-inline active" : "nav-link d-none d-sm-inline"} href="#" onClick={setForm}><span title="email-users" className="fas fa-envelope mr-1"></span>Email Invitations</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-11">
                {
                    (() => {
                        switch (activeForm.form) {
                            case "jgr-users":
                                return (
                                    <SearchForNewGroupMembers group={group} onMemberAdded={onCompletedSelection} />
                                )
                            case 'email-users':
                                return (
                                    <EmailGroupMemberInvitationsControl group={group} emails={invitations.emails} onChangeInvites={onChangeEmails} onCompletedInvites={onCompletedSelection} />
                                )
                            default:
                                return null;
                        }
                    })()
                }
                </div>
            </div>
            
        </div>
    );
};

SelectGroupMembersControl.propTypes = {
    group: PropTypes.object.isRequired,
    selectedUsers: PropTypes.array,
    onCompletedSelection: PropTypes.func
}


export default SelectGroupMembersControl;


// WEBPACK FOOTER //
// ./src/components/groups/SelectGroupMembersControl.js